import { Component, Input } from '@angular/core';
import { fadeInOut, INavbarData } from './helper';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { navbarData } from './nav-data';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  animations:[
    fadeInOut,
      trigger('rotate',[
        transition(':enter',[
          animate('1000ms',
          keyframes([
            style({transform:'rotate(0deg)',offset:'0'}),
            style({transform:'rotate(0.5turn)',offset:'1'}),
            
          ]))
        ])
      ]),
      // trigger('fadeIn',[
      //   transition(':enter',[
      //     animate('1000ms',
      //     keyframes([
      //       style({transform:'rotate(-90deg)'}),
           
            
      //     ]))
      //   ])
      // ]),
  ]
})
export class SidenavComponent {
  @Input() navData: INavbarData[] = [];
  isCollapsed: boolean = true;
  isSideNavCollapsed = false;
  screenWidth = 0;

  constructor(public dynamicTabsService: DynamicTabsService) { }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.dynamicTabsService.isCollapsed=this.isCollapsed;
  }

  handleClick(data: INavbarData): void {
    if (data.items && data.items.length > 0) {
      data.expanded = !data.expanded;
    }
  }

  getActiveClass(data: INavbarData): string {
    return data.expanded ? 'active-sublevel' : '';
  }

  closesidenav(): void {
    this.isCollapsed = false;
  }
}
